<template>
    <div class="details">
        <div class="details__information">
            <token-badge id="product-card-details-ssu-price"
                class="details__information-badge"
                partnerShortName="SSU"
                :customText="`${ssuPrice}`"
                :cardView="true"
            />

            <div class="details__information-icons">
                <i v-if="packageProducts"
                    class="icon icon-bundle-ticket"
                />
                <i v-if="reverseAuction"
                    class="icon icon-reverse-auction"
                />
            </div>
        </div>
        <div id="product-card-details-title"
            class="details__label"
        >
            {{ productTitle }}
        </div>
    </div>
</template>

<script>
// Components
import tokenBadge from '@webapp/modules/rewards/components/badges/token-badge.vue';

export default {
    name: 'fanshop-product-card-details',
    components: {
        tokenBadge,
    },
    props: {
        productTitle: {
            type: String,
            default: 'Product placeholder',
        },
        ssuPrice: {
            type: Number,
            default: 0,
        },
        reverseAuction: {
            type: Boolean,
            required: true,
        },
        packageProducts: {
            type: Boolean,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.details {
    padding: 1.5rem;

    &__information {
        display: flex;
        justify-content: space-between;
        width: 100%;

        &-icons {
            .icon {
                font-size: 2rem;
            }
        }

        &-badge {
            ::v-deep span {
                font-size: 1.4rem;
            }
        }
    }

    &__label {
        font-weight: bold;
        font-size: 1.4rem;
        line-height: 2rem;
        padding: 0.5rem 0 0.5rem 0;
        display: -webkit-box;
        /* stylelint-disable property-no-vendor-prefix */
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        /* stylelint-enable property-no-vendor-prefix */
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
</style>